import { COOKIE_CONSENT_DISALLOWED, DataCapsule, LocalStorageStrategy, NOT_FOUND, } from 'data-capsule';
import { spyOnPromise } from './spyOnPromise';
var ManagedStorage = /** @class */ (function () {
    function ManagedStorage(key) {
        this.key = key;
        this.data = {};
        this.dataCapsule = new DataCapsule({
            strategy: new LocalStorageStrategy(),
            namespace: 'DebugPanel',
        });
    }
    ManagedStorage.prototype.setItem = function (key, value) {
        this.readStorage();
        this.data[key] = value;
        this.writeStore();
    };
    ManagedStorage.prototype.getItem = function (key, defaultValue) {
        this.readStorage();
        return key in this.data ? this.data[key] : defaultValue;
    };
    ManagedStorage.prototype.getAll = function () {
        this.readStorage();
        return this.data;
    };
    ManagedStorage.prototype.writeStore = function () {
        try {
            this.dataCapsule
                .setItem(this.key, this.data, { category: 'functional' })
                .catch(function (err) {
                if (err === COOKIE_CONSENT_DISALLOWED) {
                    return;
                }
                console.error(err);
            });
        }
        catch (err) {
            console.error(err);
        }
    };
    ManagedStorage.prototype.readStorage = function () {
        var _this = this;
        try {
            spyOnPromise(function (_a) {
                var statusSymbol = _a.statusSymbol, valueSymbol = _a.valueSymbol;
                var promise = _this.dataCapsule.getItem(_this.key);
                promise.catch(function (err) {
                    if (err === NOT_FOUND) {
                        return;
                    }
                    if ((err === null || err === void 0 ? void 0 : err.message) === 'LocalStorage is not supported') {
                        return;
                    }
                    console.log("err", err);
                });
                if (!(statusSymbol in promise)) {
                    console.error('Implementation of local storage in data capsule has changed. Persistence will not work');
                    return;
                }
                var res = promise[valueSymbol];
                if (res) {
                    _this.data = res;
                }
            });
        }
        catch (err) {
            console.error(err);
        }
    };
    return ManagedStorage;
}());
export { ManagedStorage };
//# sourceMappingURL=ManagedStorage.js.map